import { Clapperboard } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const Reels = ({ content, reels }) => (
  <section id="reels" className="relative py-24 sm:py-32 bg-navy" data-testid="reels-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="font-script text-marigold text-3xl sm:text-4xl" data-testid="reels-script">
          {content?.reels_script || "Watch Us Fly"}
        </p>
        <h2 className="mt-3 font-display font-bold text-paper text-4xl sm:text-5xl" data-testid="reels-heading">
          {content?.reels_heading || "Reels From The Sky"}
        </h2>
        <p className="mt-4 font-body text-paper/70 max-w-xl mx-auto" data-testid="reels-sub">
          {content?.reels_sub || "Fresh from Instagram and YouTube — paste a link in the admin panel and it appears right here."}
        </p>
      </Reveal>

      {reels?.length ? (
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="reels-grid">
          {reels.slice(0, 6).map((reel, i) => (
            <Reveal key={reel.id} delay={(i % 3) * 0.1}>
              <div
                className="rounded-xl overflow-hidden border-2 border-marigold/50 bg-navy-deep shadow-xl shadow-black/30 hover:border-marigold transition-colors duration-300"
                data-testid={`reel-embed-${reel.platform}`}
              >
                <div className="aspect-[9/16]">
                  <iframe
                    src={reel.embed_url}
                    title={reel.title || `${reel.platform} reel`}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                {reel.title ? (
                  <p className="px-4 py-3 font-body font-semibold text-paper/90 text-sm" data-testid="reel-caption">
                    {reel.title}
                  </p>
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      ) : (
        <div
          className="mt-14 max-w-md mx-auto border-2 border-dashed border-marigold/50 rounded-2xl p-12 text-center text-paper/70 font-body"
          data-testid="reels-empty"
        >
          <Clapperboard className="w-10 h-10 mx-auto mb-4 text-marigold" />
          No reels yet. Add your first Instagram or YouTube link from the admin panel and it will appear here.
        </div>
      )}
    </div>
  </section>
);

export default Reels;
